<template>
  <div>
    <div v-if="!isLoading" class="row no-gutters mt-4">
      <div class="col-12 px-lg-5 px-0 pb-3">

        <div class="mb-3 ml-2 pl-1">
          <div class="title-text">Suppliers</div>
          <div class="mt-3">
            The suppliers on this list have been given access to Autodesk Supplier Portal. Use the search box at the top of the page to find your supplier.
            To engage a supplier not on this list, submit a <router-link class="solution-link" :to="{name: 'OneIntakeForm'}">supplier engagement request</router-link>.

            <br /><div class="py-2"><strong>Note: </strong>This is not a list of preferred suppliers. This list does not include suppliers who use Ariba Network to submit invoices, since the same information is available to them on Ariba Network.</div>
            Click Engage with Supplier to start a new engagement, including a new scope of work (SOW) or amendment.
            <div> If you have any questions about your supplier's access to the Autodesk Supplier Portal, please contact
              <a class="solution-link" target="_blank" :href="supplierPortalSlack">#adsk-supplier-portal-help</a>
              or via email:
              <ul class="mt-2">
                <li v-for="(contact, index) in CONSTANTS.SUPPLIER_EMAIL_SUPPORT" :key="index">
                  <a class="solution-link" :href="'mailto:'+contact.EMAIL_VALUE">{{contact.EMAIL_TEXT}}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <vue-good-table
            :columns="columns"
            :rows="suppliers"
            class="table-word-wrap"
            :pagination-options="{
            enabled: this.paginationEnabled,
            ...paginationOptions,
          }">
          <div slot="emptystate">{{ noRecordsMesage }}</div>
          <template slot="table-column" slot-scope="props">
            <span v-if="props.column.label === 'Company name'">
              <header-with-tooltip :tooltipText="companyNameTooltip"> {{props.column.label}} </header-with-tooltip>
            </span>
            <span v-else-if="props.column.label === 'Supplier ID'">
              <header-with-tooltip :tooltipText="supplierIdTooltip"> {{props.column.label}} </header-with-tooltip>
            </span>
            <span v-else>
              {{props.column.label}}
            </span>
          </template>
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field === 'name'">
              <div class="content row-content">
                {{ props.row.name }}
              </div>
            </span>

            <span v-else-if="props.column.field === 'actions'">
              <div class="content row-content">

                <a @click="launchOneIntakeForm(props.row.id)" class="solution-link">
                   <font-awesome-icon icon="handshake" class=" mr-2 fa-lg"></font-awesome-icon>
                    <span class="d-xl-inline d-none">Engage with Supplier</span>
                    <span class="d-xl-none d-sm-inline">Engage</span>
                </a>
              </div>
            </span>
            <span v-else>
              {{props.row[props.column.field]}}
            </span>

          </template>
        </vue-good-table>
        <div class="support-section pl-2">
          <support></support>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VueGoodTable } from "vue-good-table";
import { mapGetters, mapActions } from "vuex";
import CONSTANTS from "@/store/constants";
import HeaderWithTooltip from "@/components/HeaderWithTooltip";
import Support from "@/components/Support";
import VGT_PAGINATION_OPTIONS from "../../store/vgtPaginationOptions";

export default {
  name: "SupplierList",
  components: {HeaderWithTooltip, VueGoodTable, Support },
  created() {
    if(!this.suppliers || this.suppliers.length === 0)
      this.fetchAllSuppliers()
  },
  methods: {
    ...mapActions(["fetchAllSuppliers"]),
    launchOneIntakeForm(id) {
      let subEvent = `vendorId: `+id
      this.trackEvent("Engage with Supplier initiated",subEvent)
      this.$router.push({ name: "OneIntakeForm", query: {vendorId: id} });
    },
    trackEvent(event, subEvent) {
      this.$hhMixpanel.trackEvent(event, {subEvent})
    }
  },
  data() {
    return {
      noRecordsMesage: CONSTANTS.NO_SUPPLIERS_MESSAGE,
      companyNameTooltip: `This is the legal company name of the supplier. If you have trouble finding your supplier try variations.`,
      supplierIdTooltip: `This is our ID used in SAP/Ariba and is required for all supplier purchase orders.
              Not all suppliers paid on a credit card have a supplier ID. <br /> This list only includes suppliers we have done business with in the past 18 months.`,
      supplierPortalHelp: CONSTANTS.SUPPLIER_PORTAL_HELP.EMAIL,
      supplierPortalSlack: CONSTANTS.SUPPLIER_PORTAL_HELP.SLACK,
      paginationOptions: VGT_PAGINATION_OPTIONS.SUPPLIER_LIST_PAGINATION_OPTIONS
    }
  },
  computed: {
    ...mapGetters(["suppliers","isLoading"]),
    paginationEnabled() {
      return this.suppliers.length > 15
    },
    columns() {
      return [
        {
          label: "Company name",
          field: "name",
          type: "string",
          thClass: "sorting",
          tdClass: "align-left",
          width: "52%",
          sortFn: (x,y) => {
            return (x.trim() < y.trim() ? -1 : (x.trim() > y.trim() ? 1 : 0))
          },
          sortable: true
        },
        {
          label: "Supplier ID",
          field: "supplierId",
          type: "string",
          thClass: "hide-field-xs sorting",
          tdClass: "hide-field-xs status-field-text",
          width: "32%",
          sortFn: (x,y) => {
            return (x.trim() < y.trim() ? -1 : (x.trim() > y.trim() ? 1 : 0))
          },
          sortable: true
        },
        {
          label: "Action",
          field: "actions",
          thClass: "th-actions text-nowrap",
          tdClass: "td-actions text-nowrap",
          width: "16%",
          sortable: false,
        },
      ];
    },
  },
};
</script>

<style scoped>

</style>
<style scoped src="@/assets/stylesheets/vgtStyles.css">
</style>